import script from "./BACS-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./BACS-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"

import "./BACS-Questionnaire-Main.vue?vue&type=style&index=0&id=38d90435&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d90435"]])

export default __exports__